import React from 'react';

const ExternalAppIframe = () => {
  const url = window.config.rnl_url;

  return (
    <iframe
      src={url} // Start with default login page
      title='External App'
      width='100%'
      style={{ height: '90vh', border: 'none' }}
      referrerPolicy='origin'
      loading='eager'
    />
  );
};

export default ExternalAppIframe;
